import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/panxo/Development/LigasDeportivas/web/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/panxo/Development/LigasDeportivas/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/panxo/Development/LigasDeportivas/web/src/components/ui/RedirectTo.tsx");
